// src/components/sessionTimeoutDialog/sessionTimeoutDialog.js
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./sessionTimeoutDialog.css";

export function formatCountdown(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
}

function SessionTimeoutDialog({ show, expiresAt, onStaySignedIn, onLogoutNow }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!show) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [show]);

  return (
    <Modal show={show} onHide={onStaySignedIn} centered className="session-timeout-dialog" data-testid="session-timeout-dialog">
      <Modal.Header>
        <Modal.Title>Session Expiring Soon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You've been inactive for a while. For your security, you'll be signed out in:</p>
        <div className="session-timeout-countdown" role="timer" data-testid="session-timeout-countdown">
          {formatCountdown(expiresAt - now)}
        </div>
        <p className="mb-0">Choose Stay Signed In to keep working.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onLogoutNow} data-testid="session-timeout-logout-now">
          Log Out Now
        </Button>
        <Button variant="primary" onClick={onStaySignedIn} data-testid="session-timeout-stay-signed-in">
          Stay Signed In
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SessionTimeoutDialog;
